import { useState } from 'react';
import { ISearchedCompany } from '../types/company';
import SearchListHeader from './SearchListHeader';
import { compareNames } from '../utils/compare-functions';
import SearchListItem from './SearchListItem';

export default function SearchList({
  searchedCompanies,
  searchTerm,
  bulkMode,
}: Readonly<{
  searchedCompanies: ISearchedCompany[];
  searchTerm: string;
  bulkMode: boolean;
}>) {
  const bestMatch = bulkMode ? 'Article match' : 'Best match';
  const sortOptions = [
    { value: 'BEST_MATCH', label: bestMatch },
    { value: 'NAME_A_Z', label: 'A-Z' },
    { value: 'NAME_Z_A', label: 'Z-A' },
  ];
  const [selectedSortOption, setSelectedSortOption] = useState(sortOptions[0]);

  const compareCompanySortOrder = (companyA: ISearchedCompany, companyB: ISearchedCompany): number => {
    if (selectedSortOption.value === 'BEST_MATCH') {
      const companyAScore = companyA.score ?? 3000;
      const companyBScore = companyB.score ?? 3000;
      const scoreDifference = companyAScore - companyBScore;
      if (scoreDifference === 0) {
        return compareNames(companyA.sortable_name, companyB.sortable_name, 'UP');
      }
      return scoreDifference;
    } else if (selectedSortOption.value === 'NAME_A_Z') {
      return compareNames(companyA.sortable_name, companyB.sortable_name, 'UP');
    }
    return compareNames(companyA.sortable_name, companyB.sortable_name, 'DOWN');
  };

  return (
    <div>
      <SearchListHeader
        sortOptions={sortOptions}
        selectedSortOption={selectedSortOption}
        setSelectedSortOption={setSelectedSortOption}
        bulkMode={bulkMode}
      />
      {searchedCompanies.toSorted(compareCompanySortOrder).map((searchedCompany) => (
        <SearchListItem
          key={searchedCompany.company_code}
          company_code={searchedCompany.company_code}
          name={searchedCompany.name}
          country={searchedCompany.country}
          in_portfolio={searchedCompany.in_portfolio}
          searchTerm={searchTerm}
          bulkMode={bulkMode}
        />
      ))}
    </div>
  );
}
